import type { ThemeKey, ThemeVariantStyles } from 'Src/types/theme';
import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Icon } from 'Components/frameworks/icon/Icon';
import { themes } from './LayerHeaderButton.themes';
export type LayerHeaderButtonProps = {
  ariaHidden?: boolean;
  ariaLabel?: string;
  className?: string;
  dataTestId?: string;
  iconClassName?: string;
  iconName?: IconName;
  isActive?: boolean;
  label?: string;
  onClick?: ((e?: React.SyntheticEvent) => void) | null;
  tabIndex?: number;
  theme?: ThemeKey<typeof themes>;
};
export const LayerHeaderButton = ({
  ariaHidden,
  ariaLabel,
  className,
  dataTestId,
  iconClassName,
  iconName,
  isActive,
  label,
  onClick,
  tabIndex,
  theme = 'default',
}: LayerHeaderButtonProps) => {
  if (!label && !iconName) {
    return null;
  }

  const hasIcon = !!iconName;
  const { thIcon, thIconWidth, thLabel, thRoot } = themes({
    isActive,
    hasIcon,
  })[theme] as ThemeVariantStyles<typeof themes>;
  return (
    <button
      aria-hidden={ariaHidden}
      aria-label={ariaLabel}
      className={classnames(thRoot, className)}
      data-testid={dataTestId}
      onClick={onClick}
      {...(tabIndex === -1
        ? {
            tabIndex,
          }
        : null)}
      type="button"
    >
      {!!iconName && (
        <Icon
          className={classnames(thIcon, iconClassName)}
          hasRtl
          name={iconName}
          width={thIconWidth}
        />
      )}
      {!!label && <span className={thLabel}>{label}</span>}
    </button>
  );
};
